import {
  GET_PERFORMANCE,
  GET_PERFORMANCE_SUCCESS,
  GET_PERFORMANCE_FAIL,
  DELETE_PERFORMANCE,
  DELETE_PERFORMANCE_SUCCESS,
  DELETE_PERFORMANCE_FAIL,
  UPDATE_PERFORMANCE,
  UPDATE_PERFORMANCE_SUCCESS,
  UPDATE_PERFORMANCE_FAIL,
  ADD_NEW_PERFORMANCE,
  ADD_PERFORMANCE_SUCCESS,
  ADD_PERFORMANCE_FAIL,
  PERFORMANCE_LOADING,
  PERFORMANCE_RESET,
} from "./actionType";

export const resetPerformanceState = (actionType) => ({
  type: PERFORMANCE_RESET,
  payload: { actionType },
});

export const getPerformanceSuccess = (actionType, data) => ({
  type: GET_PERFORMANCE_SUCCESS,
  payload: { actionType, data },
});

export const getPerformanceFail = (actionType, error) => ({
  type: GET_PERFORMANCE_FAIL,
  payload: { actionType, error },
});

export const getPerformance = data => ({
  type: GET_PERFORMANCE,
  payload: data,
});

export const getPerformanceLoading = () => ({
  type: PERFORMANCE_LOADING
});

export const deletePerformance = data => ({
  type: DELETE_PERFORMANCE,
  payload: data,
});

export const deletePerformanceSuccess = data => ({
  type: DELETE_PERFORMANCE_SUCCESS,
  payload: data,
});

export const deletePerformanceFail = error => ({
  type: DELETE_PERFORMANCE_FAIL,
  payload: error,
});

export const updatePerformance = data => ({
  type: UPDATE_PERFORMANCE,
  payload: data,
});

export const updatePerformanceFail = error => ({
  type: UPDATE_PERFORMANCE_FAIL,
  payload: error,
});

export const updatePerformanceSuccess = data => ({
  type: UPDATE_PERFORMANCE_SUCCESS,
  payload: data,
});

export const addNewPerformance = data => ({
  type: ADD_NEW_PERFORMANCE,
  payload: data,
});

export const addPerformanceSuccess = data => ({
  type: ADD_PERFORMANCE_SUCCESS,
  payload: data,
});

export const addPerformanceFail = error => ({
  type: ADD_PERFORMANCE_FAIL,
  payload: error,
});